import { render, staticRenderFns } from "./FormatQuestionnaireSubmissionAttachmentResourcePropertyEditor.vue?vue&type=template&id=732cd295&scoped=true&"
import script from "./FormatQuestionnaireSubmissionAttachmentResourcePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatQuestionnaireSubmissionAttachmentResourcePropertyEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatQuestionnaireSubmissionAttachmentResourcePropertyEditor.vue?vue&type=style&index=0&id=732cd295&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732cd295",
  null
  
)

export default component.exports